module.exports = __webpack_public_path__ + "img/shape-octagon-alta-pagoda-estrella.204c4e5f.png";